import { formatQuantity } from '@kronos/domain'
import type { Receipt } from '../../data/inventory'
import { Link } from '../shell/Link'
import { ItemThumb } from '../inventory/ItemArt'
import { whenText } from '../inventory/shared'

/**
 * Recent deliveries, one row each: the item's picture, what and how many,
 * when, who, the note. Each row is a button to the item, with a chevron.
 *
 * Used by Today and Receive. (The item page draws its own deliveries as a
 * timeline — there the item is the page, and the rows would all be the same
 * picture.)
 */
export function DeliveryList({ receipts }: { receipts: readonly Receipt[] }): JSX.Element {
  return (
    <div className="panel">
      <div className="row-list">
        {receipts.map((r) => {
          const qty = formatQuantity(r.quantity, r.unit)
          const each = r.unit === '' || r.unit === 'each'
          const meta = [whenText(r.receivedAt), r.receivedBy, r.note].filter(Boolean).join(' · ')
          return (
            <Link key={r.id} to={{ name: 'item', id: r.itemId }} className="row-item inv-delivery">
              <ItemThumb imageId={r.itemImageId} category={r.itemCategory} name={r.itemName} size={44} />
              <span className="row-item__main inv-delivery__main">
                <span className="row-item__title">
                  <span className="figure">{qty}</span> {each ? '×' : 'of'} {r.itemName}
                </span>
                <span className="row-item__meta">{meta}</span>
              </span>
              {r.units.length > 0 ? (
                <span className="row-item__side inv-hide-phone">
                  <span className="serial">{r.units[0]?.serial}</span>
                  {r.units.length > 1 ? <span>+{r.units.length - 1}</span> : null}
                </span>
              ) : null}
            </Link>
          )
        })}
      </div>
    </div>
  )
}
